import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <header className="hero">
        <h1 className="logo-glow">Sunday Night <span>Bowling</span></h1>
        <p>Track stats. Settle rivalries. Win the beer frame.</p>
      </header>

      <div className="action-grid">
        <div className="action-card" onClick={() => navigate('/submit')}>
          <div className="icon">🎳</div>
          <h3>Start Game</h3>
          <p>Enter scores for tonight's frames</p>
        </div>

        <div className="action-card" onClick={() => navigate('/leaderboard')}>
          <div className="icon">🏆</div>
          <h3>Leaderboard</h3>
          <p>See who's currently on top</p>
        </div>

        <div className="action-card" onClick={() => navigate('/stats')}>
          <div className="icon">📊</div>
          <h3>My Stats</h3>
          <p>Deep dive into your performance</p>
        </div>

        <div className="action-card scan" onClick={() => navigate('/scan')}>
          <div className="icon">📸</div>
          <h3>Scan Score</h3>
          <p>Use AI to read the overhead screen</p>
        </div>
      </div>
    </div>
  );
}